// Get the element
var productGridEl = document.querySelector(".product-grid-slider");

// Read the attribute (default to 4 if not set)
var productsPerRow = parseInt(productGridEl.getAttribute("data_products_per_row")) || 4;

// Initialize Swiper
var productgridslider = new Swiper(".product-grid-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    breakpoints: {
        0: {
            slidesPerView: 1,
        },
        767: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 2,
        },
        769: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 3,
        },
        1199: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: productsPerRow, // Use attribute value for desktop
        }
    },
    navigation: {
        nextEl: ".product-grid-slider .swiper-button-next",
        prevEl: ".product-grid-slider .swiper-button-prev",
    },
});
